export default "__VITE_ASSET__BrOh0ujj__"